import { render } from "./ProfitLoss copy.vue?vue&type=template&id=19df5236&scoped=true"
import script from "./ProfitLoss copy.vue?vue&type=script&lang=js"
export * from "./ProfitLoss copy.vue?vue&type=script&lang=js"

import "./ProfitLoss copy.vue?vue&type=style&index=0&id=19df5236&scoped=true&lang=css"

import exportComponent from "D:\\DockerProjects\\armt_pos_v2_docker\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19df5236"]])

export default __exports__